import { ethers } from "ethers";
import { toast } from "react-toastify";

function useEthers() {
  const connectWallet = async () => {
    if (window.ethereum) {
      try {
        await window.ethereum.request({ method: "eth_requestAccounts" });
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const address = await signer.getAddress();
        const network = provider.getNetwork();
        const chainId = (await network).chainId;

        return { signer, address, chainId, provider };
      } catch (error) {
        console.error("Failed to connect wallet:", error.message);
        toast.error("ailed to connect walle!");
      }
    } else {
      console.error("MetaMask is not installed!");
      toast.error("MetaMask is not installed!");
    }
  };

  return { connectWallet };
}

export default useEthers;
